@if (!mobile) {
  <rk-modal-wrapper
    [submitText]="'SCHEDULE.PLANNING.EDIT_MODAL_SAVE' | translate"
    (submitted)="saveClicked()"
    [title]="
      (isEdition
        ? 'SCHEDULE.PLANNING.EDIT_MODAL_TITLE'
        : 'SCHEDULE.PLANNING.CREATE_MODAL_TITLE'
      ) | translate
    "
    [sticky]="true"
    [isSubmitDisabled]="
      form.invalid ||
      (isLoading$ | async) ||
      (activeTab === enums.SlotKind.program && !(hasPrograms$ | async)) ||
      (activeTab === enums.SlotKind.playlist && !(hasPlaylists$ | async))
    "
    (cancelled)="closeSelf()"
    (closed)="closeSelf()"
  >
    <div *ngIf="!isEdition" class="mb-base">
      <mat-button-toggle-group data-cy="tab-toggle" (change)="changeActiveTab($event)">
        <mat-button-toggle
          [value]="enums.SlotKind.playlist"
          [checked]="(hasPlaylists$ | async) && activeTab === enums.SlotKind.playlist"
          [disabled]="!(hasPlaylists$ | async)"
          rkTooltip
          [tooltipDescription]="'SCHEDULE.PLANNING.EDIT_MODAL_NO_PLAYLIST' | translate"
          [tooltipDisabled]="hasPlaylists$ | async"
          tooltipPosition="bottom"
        >
          <mat-icon fontSet="fa" fontIcon="fa-list"></mat-icon>
          {{ 'SCHEDULE.PLANNING.EDIT_MODAL_TAB_PLAYLIST' | translate }}</mat-button-toggle
        >
        <mat-button-toggle
          [value]="enums.SlotKind.program"
          [checked]="!(hasPlaylists$ | async) || activeTab === enums.SlotKind.program"
          [disabled]="!(hasPrograms$ | async)"
          rkTooltip
          [tooltipDescription]="'SCHEDULE.PLANNING.EDIT_MODAL_NO_PROGRAM' | translate"
          [tooltipDisabled]="hasPrograms$ | async"
          tooltipPosition="bottom"
          arrowPosition="right"
        >
          <mat-icon fontSet="fa" fontIcon="fa-clock"></mat-icon>
          {{ 'SCHEDULE.PLANNING.EDIT_MODAL_TAB_PROGRAM' | translate }}</mat-button-toggle
        >
      </mat-button-toggle-group>
    </div>
    <form class="planning-slot-edition--form" [formGroup]="form" novalidate>
      <rk-dropdown-autocomplete
        class="dropdown"
        *ngIf="activeTab === enums.SlotKind.program"
        [label]="'SCHEDULE.PLANNING.EDIT_MODAL_FIELD_PROGRAM_LABEL' | translate"
        [placeholder]="'PLAYLIST.SEARCH_BAR.PLACEHOLDER' | translate"
        formControlName="program"
        [data]="allPrograms$ | async"
        [modal]="true"
        [renderLineTemplate]="renderProgramDropdownItemTmpl"
        [iconTemplate]="renderProgramDropdownIconTmpl"
      ></rk-dropdown-autocomplete>
      <ng-template let-program="item" #renderProgramDropdownItemTmpl>
        <div class="dropdown-program-title-container">
          <div
            class="dropdown-program-color"
            [style.backgroundColor]="program.color"
          ></div>
          <div class="dropdown-program-title">
            {{ program.name }}
          </div>
        </div>
      </ng-template>
      <ng-template let-program="item" #renderProgramDropdownIconTmpl>
        <div
          class="dropdown-program-color--selected"
          [style.backgroundColor]="program.color"
        ></div>
      </ng-template>
      <rk-dropdown-autocomplete
        class="dropdown"
        *ngIf="activeTab === enums.SlotKind.playlist"
        [label]="'SCHEDULE.PLANNING.EDIT_MODAL_FIELD_PLAYLIST_LABEL' | translate"
        [placeholder]="'PLAYLIST.SEARCH_BAR.PLACEHOLDER' | translate"
        formControlName="playlist"
        [data]="allPlaylists$ | async"
        [modal]="true"
        [renderLineTemplate]="renderPlaylistDropdownItemTmpl"
        [iconTemplate]="renderPlaylistDropdownIconTmpl"
      ></rk-dropdown-autocomplete>

      <div class="dates">
        <rk-form-field
          class="date"
          [label]="'SCHEDULE.PLANNING.EDIT_MODAL_FIELD_DATE_DAY_LABEL' | translate"
        >
          <mat-icon
            class="date-input-icon"
            fontSet="fas"
            fontIcon="fa-calendar-alt"
          ></mat-icon>
          <input
            class="date-input-field"
            type="text"
            rkDaterangepicker
            rkInput
            readonly
            formControlName="dateDay"
            required
            [singleDatePicker]="true"
            [minDate]="minDate"
            [value]="formattedSlotDate"
            [autoApply]="true"
            [updateInputValue]="false"
            (datesUpdated)="slotDateChanged($event)"
          />
        </rk-form-field>
        <rk-form-field
          class="date"
          [label]="'SCHEDULE.PLANNING.EDIT_MODAL_FIELD_DATE_START_LABEL' | translate"
        >
          <mat-icon class="date-input-icon" fontSet="fa" fontIcon="fa-clock"></mat-icon>
          <input
            type="time"
            rkInput
            formControlName="dateStart"
            (input)="changeDuration()"
            required
          />
          <rk-form-error
            class="absolute w-[240px] mt-1"
            *ngIf="form.get('dateEnd').invalid || form.get('dateStart').invalid"
            [errorMessage]="'SCHEDULE.PLANNING.EDIT_MODAL_HOUR_ERROR' | translate"
          ></rk-form-error>
        </rk-form-field>
        <rk-form-field
          class="date"
          [label]="'SCHEDULE.PLANNING.EDIT_MODAL_FIELD_DATE_END_LABEL' | translate"
        >
          <mat-icon class="date-input-icon" fontSet="fa" fontIcon="fa-clock"></mat-icon>
          <input
            type="time"
            rkInput
            formControlName="dateEnd"
            (input)="changeDuration()"
            required
          />
          <mat-icon
            *ngIf="activeTab === enums.SlotKind.playlist && durationEdited"
            class="date-magic-icon tooltip-magic-icon"
            fontSet="fas"
            fontIcon="fa-magic"
            rkTooltip
            [tooltipDescription]="'SCHEDULE.PLANNING.EDIT_MODAL_MAGIC_ICON' | translate"
            [arrowPosition]="'right'"
            (click)="setDurationToPlaylistTime(true)"
          ></mat-icon>
        </rk-form-field>
      </div>

      <rk-form-field
        [label]="'SCHEDULE.PLANNING.BROADCAST_TYPE' | translate"
        [hintQuestionMark]="'SCHEDULE.PLANNING.BROADCAST_TYPE_HINT' | translate"
      >
        <mat-button-toggle-group formControlName="playType" class="mt-2">
          <mat-button-toggle value="sequential"
            ><mat-icon fontSet="fa" fontIcon="fa-list"></mat-icon
            >{{
              'SCHEDULE.PLANNING.EDIT_MODAL_FIELD_PLAY_TYPE_VALUE_ORDER' | translate
            }}</mat-button-toggle
          >
          <mat-button-toggle value="random">
            <mat-icon fontSet="fa" fontIcon="fa-random"></mat-icon>
            {{
              'SCHEDULE.PLANNING.EDIT_MODAL_FIELD_PLAY_TYPE_VALUE_RANDOM' | translate
            }}</mat-button-toggle
          >
        </mat-button-toggle-group>
      </rk-form-field>

      <rk-form-field class="fixed-time" [class.tolerance-active]="isToleranceVisible">
        <mat-slide-toggle formControlName="fixedTime">
          <label class="label">
            {{ 'SCHEDULE.PLANNING.EDIT_MODAL_FIELD_FIXED_TIME_LABEL' | translate }}
          </label>
        </mat-slide-toggle>
        <div *ngIf="isToleranceVisible" class="tolerance">
          {{ 'SCHEDULE.PLANNING.EDIT_MODAL_FIELD_WITH_TOLERANCE' | translate }}
          <input
            class="number-input-field"
            type="number"
            rkInput
            formControlName="tolerance"
            min="0"
          />
          {{ 'SCHEDULE.PLANNING.EDIT_MODAL_FIELD_FIXED_TIME_UNIT_INFO' | translate }}
        </div>
        <rk-question-mark
          [description]="
            !isToleranceVisible
              ? ('SCHEDULE.PLANNING.EDIT_MODAL_FIELD_FIXED_TIME_HELP' | translate)
              : ('SCHEDULE.PLANNING.EDIT_MODAL_FIELD_TOLERANCE_HELP' | translate)
          "
        >
        </rk-question-mark>
      </rk-form-field>

      <div class="repeat-container bg-gray-hover">
        <div class="flex justify-between">
          <span class="label" translate>SCHEDULE.PLANNING.EDIT_MODAL_FIELD_REPEAT</span>
          <mat-slide-toggle formControlName="repeat"></mat-slide-toggle>
        </div>
        <div *ngIf="isRepeatActive" class="repeat-fields">
          <rk-colored-hint [type]="'warning'" *ngIf="showHint()">
            <div class="flex items-center">
              <span translate>SCHEDULE.PLANNING.EDIT_MODAL_REPEAT_MAX_DURATION</span>
              <rk-icon-button
                faIcon="fa-times"
                color="brand"
                (click)="dismiss6MonthHint()"
              ></rk-icon-button>
            </div>
          </rk-colored-hint>
          <rk-dropdown-autocomplete
            class="dropdown mb-base"
            formControlName="frequency"
            [data]="frequencyList"
            [modal]="true"
            [isAbsolute]="true"
          ></rk-dropdown-autocomplete>
          <ng-container *ngIf="isDaysVisible">
            <label class="label" translate
              >SCHEDULE.PLANNING.EDIT_MODAL_FIELD_REPEAT_DAYS</label
            >
            <rk-weekday-select formControlName="weekdays"></rk-weekday-select>
          </ng-container>
          <div class="repeat-until mt-base">
            <div class="label" translate>SCHEDULE.PLANNING.EDIT_MODAL_LABEL_ENDS</div>
            <rk-form-field class="-mt-1">
              <mat-radio-group class="flex flex-col" formControlName="repeatChoice">
                <mat-radio-button value="date" class="mb-2.5">
                  <div class="flex items-center">
                    <span class="mr-1.5" translate
                      >SCHEDULE.PLANNING.EDIT_MODAL_LABEL_ENDS_ON</span
                    >
                    <div class="relative">
                      <mat-icon
                        class="date-input-icon"
                        fontSet="fas"
                        fontIcon="fa-calendar-alt"
                      ></mat-icon>
                      <input
                        class="date-input-field !mt-0"
                        [class.disabled]="form.get('repeatChoice').value !== 'date'"
                        type="text"
                        rkDaterangepicker
                        rkInput
                        readonly
                        formControlName="repeatEnd"
                        [singleDatePicker]="true"
                        [maxDate]="repeatMaxDate"
                        [value]="formattedRepeatDate"
                        [autoApply]="true"
                        [updateInputValue]="false"
                        (datesUpdated)="repeatDateChanged($event)"
                      />
                    </div>
                  </div>
                </mat-radio-button>
                <mat-radio-button value="occurrences">
                  <span translate>SCHEDULE.PLANNING.EDIT_MODAL_LABEL_ENDS_AFTER</span>
                  <input
                    class="number-input-field"
                    [class.disabled]="form.get('repeatChoice').value !== 'occurrences'"
                    type="number"
                    rkInput
                    formControlName="repeatOccurrences"
                    min="1"
                    max="180"
                  />
                  <span translate
                    >SCHEDULE.PLANNING.EDIT_MODAL_LABEL_ENDS_AFTER_REPEATS</span
                  >
                </mat-radio-button>
              </mat-radio-group>
            </rk-form-field>
          </div>
        </div>
      </div>

      <div class="inlay-container">
        <div class="flex justify-between items-center">
          <span class="label" translate>SCHEDULE.PLANNING.EDIT_MODAL_FIELD_INLAY</span>
          <rk-question-mark
            class="mr-auto"
            [description]="'SCHEDULE.PLANNING.EDIT_MODAL_FIELD_INLAY_TOOLTIP' | translate"
          >
          </rk-question-mark>
          <mat-slide-toggle formControlName="inlay"></mat-slide-toggle>
        </div>
        <div *ngIf="isInlayActive" class="inlay-fields">
          <mat-button-toggle-group formControlName="inlayType">
            <mat-button-toggle [value]="'track'">
              <mat-icon fontSet="fa" fontIcon="fa-random"></mat-icon>
              {{
                'SCHEDULE.PLANNING.EDIT_MODAL_INLAY_TRACK' | translate
              }}</mat-button-toggle
            >
            <mat-button-toggle
              [value]="'playlist'"
              [disabled]="!(hasPlaylists$ | async)"
              rkTooltip
              [tooltipDescription]="
                'SCHEDULE.PLANNING.EDIT_MODAL_NO_PLAYLIST' | translate
              "
              [tooltipDisabled]="hasPlaylists$ | async"
              tooltipPosition="top"
              arrowPosition="right"
              (click)="clickInlayChoice('playlist')"
            >
              <mat-icon fontSet="fa" fontIcon="fa-list"></mat-icon>
              {{
                'SCHEDULE.PLANNING.EDIT_MODAL_TAB_PLAYLIST' | translate
              }}</mat-button-toggle
            >
          </mat-button-toggle-group>
          <ng-container
            *ngIf="form.get('inlayType').value === 'track'; else inlayPlaylist"
          >
            <rk-track-input-with-suggestions
              data-cy="inlay-track"
              class="dropdown mt-base"
              [currentValue]="form.value['inlayTrack']"
              [label]="'SCHEDULE.PLANNING.EDIT_MODAL_INLAY_TRACK' | translate"
              [placeholder]="'MEDIA.SEARCH_BAR.PLACEHOLDER' | translate"
              [schedulerSearch]="true"
              (submitted)="setInlayTrack($event)"
              (blurred)="setInlayTrack(null)"
              (click)="clickInlayChoice()"
            ></rk-track-input-with-suggestions>
          </ng-container>
          <ng-template #inlayPlaylist>
            <div class="flex mt-base">
              <rk-dropdown-autocomplete
                class="dropdown flex-1"
                [label]="'SCHEDULE.PLANNING.EDIT_MODAL_FIELD_PLAYLIST_LABEL' | translate"
                [placeholder]="'PLAYLIST.SEARCH_BAR.PLACEHOLDER' | translate"
                formControlName="inlayPlaylist"
                [data]="allPlaylists$ | async"
                [modal]="true"
                [renderLineTemplate]="renderPlaylistDropdownItemTmpl"
                [iconTemplate]="renderPlaylistDropdownIconTmpl"
                (click)="clickInlayPlaylist()"
              ></rk-dropdown-autocomplete>
              <rk-form-field
                class="ml-3 w-36"
                [label]="'SCHEDULE.PLANNING.EDIT_MODAL_FIELD_TRACKS' | translate"
              >
                <input
                  type="number"
                  rkInput
                  formControlName="inlayPlaylistTracks"
                  min="1"
                  (focus)="clickInlayPlaylist('number')"
                />
              </rk-form-field>
            </div>
          </ng-template>
          <rk-form-field class="mt-base">
            <div>
              {{ 'SCHEDULE.PLANNING.EDIT_MODAL_FIELD_INLAY_REPEAT' | translate }}
              <input
                class="number-input-field"
                type="number"
                rkInput
                formControlName="inlayRepeat"
                min="1"
                (focus)="clickInlayPlaylist('repeat')"
              />
              {{ 'SCHEDULE.PLANNING.EDIT_MODAL_FIELD_FIXED_TIME_UNIT_INFO' | translate }}
            </div>
          </rk-form-field>
        </div>
      </div>
    </form>
  </rk-modal-wrapper>
} @else {
  <!-- MOBILE CONTENT -->
  <rk-mobile-close-button (click)="closeSelf()"></rk-mobile-close-button>
  <div class="step-container bg-gray-hover py-5">
    <div class="flex items-baseline gap-1">
      <rk-page-title
        class="pl-5 -mb-3"
        [title]="
          (isEdition
            ? 'SCHEDULE.PLANNING.EDIT_MODAL_TITLE'
            : 'SCHEDULE.PLANNING.CREATE_MODAL_TITLE'
          ) | translate
        "
      ></rk-page-title>
      <div class="text-gray-darkest">{{ $step() + 1 }}/4</div>
    </div>

    <form class="planning-slot-edition--form" [formGroup]="form" novalidate>
      <mat-stepper linear class="flex-1 -mx-5 no-header full-height" #stepper>
        <!--- Step 1 -->
        <mat-step>
          <div class="w-screen">
            <div class="m-4 mt-0">
              <div class="text-base text-gray-darkest" translate>
                SCHEDULE.PLANNING.SELECT_CONTENT_HINT
              </div>
              <div class="mt-4">
                <rk-search-bar #searchBar (inputted)="editSearch($event)"></rk-search-bar>
              </div>
            </div>
            <div class="scrollable tiny-scroll">
              @let programList = restrictedProgramList();
              @let playlistList = restrictedPlaylistList();
              @if ((hasPrograms$ | async) && programList.length > 0) {
                <div class="section-title" translate>
                  SIDENAV.MENU.PROGRAMS
                  @if ($filteredPrograms().length > 4) {
                    <div class="link" (click)="toggleAllPrograms()">
                      {{
                        $seeAllPrograms()
                          ? ('SCHEDULE.PLANNING.SEE_LESS' | translate)
                          : ('SCHEDULE.PLANNING.SEE_ALL' | translate)
                      }}
                    </div>
                  }
                </div>
                <div class="px-6 py-0.5 bg-white">
                  @for (program of programList; track program.id; let i = $index) {
                    <div
                      class="line"
                      [class.selected]="program.id === form.value['program']?.id"
                      (click)="selectProgram(program)"
                    >
                      <div
                        class="color h-2.5 aspect-square rounded-sm"
                        [style.background]="program.color"
                      ></div>
                      <div class="name truncate">{{ program.name }}</div>
                    </div>
                  }
                </div>
              }
              @if ((hasPlaylists$ | async) && playlistList.length > 0) {
                <div class="section-title" translate>
                  MEDIA.PLAYLISTS.TITLE
                  @if ($filteredPlaylists().length > 4) {
                    <div class="link" (click)="toggleAllPlaylists()">
                      {{
                        $seeAllPlaylists()
                          ? ('SCHEDULE.PLANNING.SEE_LESS' | translate)
                          : ('SCHEDULE.PLANNING.SEE_ALL' | translate)
                      }}
                    </div>
                  }
                </div>
                <div class="px-6 py-0.5 bg-white">
                  @for (playlist of playlistList; track playlist.id; let i = $index) {
                    <div
                      class="line"
                      [class.selected]="playlist.id === form.value['playlist']?.id"
                      (click)="selectPlaylist(playlist)"
                    >
                      <rk-playlist-icon [playlist]="playlist"></rk-playlist-icon>
                      <div class="name truncate">{{ playlist.name }}</div>
                    </div>
                  }
                </div>
              }

              @if (programList.length === 0 && playlistList.length === 0) {
                <div
                  rkContainer
                  class="flex flex-col items-center mx-5 py-4 gap-4 text-base"
                >
                  <img src="/assets/search-empty.svg" alt="" />
                  <div>
                    {{
                      'MEDIA.TABLE.SEARCH_EMPTY'
                        | translate: { search: searchSubject.value }
                    }}
                  </div>
                </div>
              }
            </div>
          </div>
        </mat-step>
        <!--- Step 2 -->
        <mat-step>
          <div class="w-screen">
            <div class="m-4 mt-0">
              <div class="text-base text-gray-darkest" translate>
                SCHEDULE.PLANNING.SELECT_DATE_HINT
              </div>
            </div>
            <div class="scrollable px-5 gap-5">
              <rk-form-field
                class="date"
                [label]="'SCHEDULE.PLANNING.EDIT_MODAL_FIELD_DATE_DAY_LABEL' | translate"
              >
                <mat-icon
                  class="date-input-icon"
                  fontSet="fas"
                  fontIcon="fa-calendar-alt"
                ></mat-icon>
                <input
                  class="date-input-field"
                  type="text"
                  rkDaterangepicker
                  rkInput
                  readonly
                  formControlName="dateDay"
                  required
                  [singleDatePicker]="true"
                  [minDate]="minDate"
                  [value]="formattedSlotDate"
                  [autoApply]="true"
                  [updateInputValue]="false"
                  (datesUpdated)="slotDateChanged($event)"
                />
              </rk-form-field>
              <div class="dates gap-5">
                <rk-form-field
                  class="date"
                  [label]="
                    'SCHEDULE.PLANNING.EDIT_MODAL_FIELD_DATE_START_LABEL' | translate
                  "
                >
                  <mat-icon
                    class="date-input-icon"
                    fontSet="fa"
                    fontIcon="fa-clock"
                  ></mat-icon>
                  <input
                    type="time"
                    rkInput
                    formControlName="dateStart"
                    (input)="changeDuration()"
                    required
                  />
                  <rk-form-error
                    class="absolute w-[240px] mt-1"
                    *ngIf="form.get('dateEnd').invalid || form.get('dateStart').invalid"
                    [errorMessage]="'SCHEDULE.PLANNING.EDIT_MODAL_HOUR_ERROR' | translate"
                  ></rk-form-error>
                </rk-form-field>
                <rk-form-field
                  class="date"
                  [label]="
                    'SCHEDULE.PLANNING.EDIT_MODAL_FIELD_DATE_END_LABEL' | translate
                  "
                >
                  <mat-icon
                    class="date-input-icon"
                    fontSet="fa"
                    fontIcon="fa-clock"
                  ></mat-icon>
                  <input
                    type="time"
                    rkInput
                    formControlName="dateEnd"
                    (input)="changeDuration()"
                    required
                  />
                  <mat-icon
                    *ngIf="activeTab === enums.SlotKind.playlist && durationEdited"
                    class="date-magic-icon tooltip-magic-icon"
                    fontSet="fas"
                    fontIcon="fa-magic"
                    (click)="setDurationToPlaylistTime(true, true)"
                  ></mat-icon>
                </rk-form-field>
              </div>

              <rk-form-field
                [label]="'SCHEDULE.PLANNING.BROADCAST_TYPE' | translate"
                [hintQuestionMark]="'SCHEDULE.PLANNING.BROADCAST_TYPE_HINT' | translate"
              >
                <mat-button-toggle-group formControlName="playType" class="mt-2">
                  <mat-button-toggle value="sequential"
                    ><mat-icon fontSet="fa" fontIcon="fa-list"></mat-icon
                    >{{
                      'SCHEDULE.PLANNING.EDIT_MODAL_FIELD_PLAY_TYPE_VALUE_ORDER'
                        | translate
                    }}</mat-button-toggle
                  >
                  <mat-button-toggle value="random">
                    <mat-icon fontSet="fa" fontIcon="fa-random"></mat-icon>
                    {{
                      'SCHEDULE.PLANNING.EDIT_MODAL_FIELD_PLAY_TYPE_VALUE_RANDOM'
                        | translate
                    }}</mat-button-toggle
                  >
                </mat-button-toggle-group>
              </rk-form-field>

              <rk-form-field
                class="fixed-time"
                [class.tolerance-active]="isToleranceVisible"
              >
                <mat-slide-toggle formControlName="fixedTime">
                  <label class="label">
                    {{
                      'SCHEDULE.PLANNING.EDIT_MODAL_FIELD_FIXED_TIME_LABEL' | translate
                    }}
                  </label>
                </mat-slide-toggle>
                <rk-question-mark
                  [description]="
                    !isToleranceVisible
                      ? ('SCHEDULE.PLANNING.EDIT_MODAL_FIELD_FIXED_TIME_HELP' | translate)
                      : ('SCHEDULE.PLANNING.EDIT_MODAL_FIELD_TOLERANCE_HELP' | translate)
                  "
                >
                </rk-question-mark>
                <div class="w-full"></div>
                <div class="tolerance" [class.hidden]="!isToleranceVisible">
                  {{
                    'SCHEDULE.PLANNING.EDIT_MODAL_FIELD_WITH_TOLERANCE_MOB' | translate
                  }}
                  <input
                    class="number-input-field"
                    type="number"
                    rkInput
                    formControlName="tolerance"
                    min="0"
                  />
                  {{
                    'SCHEDULE.PLANNING.EDIT_MODAL_FIELD_FIXED_TIME_UNIT_INFO' | translate
                  }}
                </div>
              </rk-form-field>
            </div>
          </div>
        </mat-step>
        <!--- Step 3 -->
        <mat-step>
          <div class="w-screen">
            <div class="m-4 mt-0">
              <div class="text-base text-gray-darkest" translate>
                SCHEDULE.PLANNING.REPEAT_HINT
              </div>
            </div>
            <div class="scrollable px-5 gap-5">
              <div class="repeat-container">
                <div class="flex justify-between">
                  <span class="label" translate
                    >SCHEDULE.PLANNING.EDIT_MODAL_FIELD_REPEAT</span
                  >
                  <mat-slide-toggle formControlName="repeat"></mat-slide-toggle>
                </div>
                <div
                  class="repeat-fields"
                  [class]="!isRepeatActive ? 'opacity-50 pointer-events-none' : ''"
                >
                  <rk-colored-hint [type]="'warning'" *ngIf="showHint()">
                    <div class="flex items-center">
                      <span translate
                        >SCHEDULE.PLANNING.EDIT_MODAL_REPEAT_MAX_DURATION</span
                      >
                      <rk-icon-button
                        faIcon="fa-times"
                        color="brand"
                        (click)="dismiss6MonthHint()"
                      ></rk-icon-button>
                    </div>
                  </rk-colored-hint>
                  <rk-dropdown-autocomplete
                    class="dropdown mb-base"
                    formControlName="frequency"
                    [data]="frequencyList"
                    [modal]="true"
                    [isAbsolute]="true"
                    [noAutocomplete]="true"
                  ></rk-dropdown-autocomplete>
                  <ng-container *ngIf="isDaysVisible">
                    <label class="label" translate
                      >SCHEDULE.PLANNING.EDIT_MODAL_FIELD_REPEAT_DAYS</label
                    >
                    <rk-weekday-select formControlName="weekdays"></rk-weekday-select>
                  </ng-container>
                  <div class="repeat-until mt-base">
                    <div class="label" translate>
                      SCHEDULE.PLANNING.EDIT_MODAL_LABEL_ENDS
                    </div>
                    <rk-form-field class="-mt-1">
                      <mat-radio-group
                        class="flex flex-col"
                        formControlName="repeatChoice"
                      >
                        <mat-radio-button value="date" class="mb-2.5">
                          <div class="flex items-center">
                            <span class="mr-1.5" translate
                              >SCHEDULE.PLANNING.EDIT_MODAL_LABEL_ENDS_ON</span
                            >
                            <div class="relative">
                              <mat-icon
                                class="date-input-icon"
                                fontSet="fas"
                                fontIcon="fa-calendar-alt"
                              ></mat-icon>
                              <input
                                class="date-input-field !mt-0"
                                [class.disabled]="
                                  form.get('repeatChoice').value !== 'date'
                                "
                                type="text"
                                rkDaterangepicker
                                rkInput
                                readonly
                                formControlName="repeatEnd"
                                [singleDatePicker]="true"
                                [maxDate]="repeatMaxDate"
                                [value]="formattedRepeatDate"
                                [autoApply]="true"
                                [updateInputValue]="false"
                                (datesUpdated)="repeatDateChanged($event)"
                              />
                            </div>
                          </div>
                        </mat-radio-button>
                        <mat-radio-button value="occurrences">
                          <span translate
                            >SCHEDULE.PLANNING.EDIT_MODAL_LABEL_ENDS_AFTER</span
                          >
                          <input
                            class="number-input-field"
                            [class.disabled]="
                              form.get('repeatChoice').value !== 'occurrences'
                            "
                            type="number"
                            rkInput
                            formControlName="repeatOccurrences"
                            min="1"
                            max="180"
                          />
                          <span translate
                            >SCHEDULE.PLANNING.EDIT_MODAL_LABEL_ENDS_AFTER_REPEATS</span
                          >
                        </mat-radio-button>
                      </mat-radio-group>
                    </rk-form-field>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-step>
        <!--- Step 4 -->
        <mat-step>
          <div class="w-screen">
            <div class="m-4 mt-0">
              <div class="text-base text-gray-darkest" translate>
                SCHEDULE.PLANNING.INLAY_HINT
              </div>
            </div>
            <div class="scrollable px-5 gap-5">
              <div class="inlay-container">
                <div class="flex justify-between items-center">
                  <span class="label" translate
                    >SCHEDULE.PLANNING.EDIT_MODAL_FIELD_INLAY</span
                  >
                  <rk-question-mark
                    class="mr-auto"
                    [description]="
                      'SCHEDULE.PLANNING.EDIT_MODAL_FIELD_INLAY_TOOLTIP' | translate
                    "
                  >
                  </rk-question-mark>
                  <mat-slide-toggle formControlName="inlay"></mat-slide-toggle>
                </div>
                <div
                  class="inlay-fields"
                  [class]="!isInlayActive ? 'opacity-50 pointer-events-none' : ''"
                >
                  <mat-button-toggle-group formControlName="inlayType">
                    <mat-button-toggle [value]="'track'">
                      <mat-icon fontSet="fa" fontIcon="fa-random"></mat-icon>
                      {{
                        'SCHEDULE.PLANNING.EDIT_MODAL_INLAY_TRACK' | translate
                      }}</mat-button-toggle
                    >
                    <mat-button-toggle
                      [value]="'playlist'"
                      [disabled]="!(hasPlaylists$ | async)"
                      rkTooltip
                      [tooltipDescription]="
                        'SCHEDULE.PLANNING.EDIT_MODAL_NO_PLAYLIST' | translate
                      "
                      [tooltipDisabled]="hasPlaylists$ | async"
                      tooltipPosition="top"
                      arrowPosition="right"
                      (click)="clickInlayChoice('playlist')"
                    >
                      <mat-icon fontSet="fa" fontIcon="fa-list"></mat-icon>
                      {{
                        'SCHEDULE.PLANNING.EDIT_MODAL_TAB_PLAYLIST' | translate
                      }}</mat-button-toggle
                    >
                  </mat-button-toggle-group>
                  @if (form.get('inlayType').value === 'track') {
                    <rk-track-input-with-suggestions
                      data-cy="inlay-track"
                      class="dropdown mt-base"
                      [currentValue]="form.value['inlayTrack']"
                      [label]="'SCHEDULE.PLANNING.EDIT_MODAL_INLAY_TRACK' | translate"
                      [placeholder]="'MEDIA.SEARCH_BAR.PLACEHOLDER' | translate"
                      [schedulerSearch]="true"
                      (submitted)="setInlayTrack($event)"
                      (blurred)="setInlayTrack(null)"
                      (click)="clickInlayChoice()"
                    ></rk-track-input-with-suggestions>
                  } @else {
                    <div class="flex flex-col mt-base">
                      <rk-dropdown-autocomplete
                        class="dropdown flex-1"
                        [label]="
                          'SCHEDULE.PLANNING.EDIT_MODAL_FIELD_PLAYLIST_LABEL' | translate
                        "
                        [placeholder]="'PLAYLIST.SEARCH_BAR.PLACEHOLDER' | translate"
                        formControlName="inlayPlaylist"
                        [data]="allPlaylists$ | async"
                        [modal]="true"
                        [renderLineTemplate]="renderPlaylistDropdownItemTmpl"
                        [iconTemplate]="renderPlaylistDropdownIconTmpl"
                        (click)="clickInlayPlaylist()"
                      ></rk-dropdown-autocomplete>
                      <rk-form-field
                        class="mt-3"
                        [label]="'SCHEDULE.PLANNING.EDIT_MODAL_FIELD_TRACKS' | translate"
                      >
                        <input
                          type="number"
                          rkInput
                          formControlName="inlayPlaylistTracks"
                          min="1"
                          class="!max-w-36"
                          (focus)="clickInlayPlaylist('number')"
                        />
                      </rk-form-field>
                    </div>
                  }

                  <rk-form-field class="mt-base">
                    <div>
                      {{ 'SCHEDULE.PLANNING.EDIT_MODAL_FIELD_INLAY_REPEAT' | translate }}
                      <input
                        class="number-input-field"
                        type="number"
                        rkInput
                        formControlName="inlayRepeat"
                        min="1"
                        (focus)="clickInlayPlaylist('repeat')"
                      />
                      {{
                        'SCHEDULE.PLANNING.EDIT_MODAL_FIELD_FIXED_TIME_UNIT_INFO'
                          | translate
                      }}
                    </div>
                  </rk-form-field>
                </div>
              </div>
            </div>
          </div>
        </mat-step>
      </mat-stepper>
    </form>
    <rk-footer-actions
      [submitText]="
        $step() === 3
          ? isEdition
            ? ('GLOBAL.EDIT' | translate)
            : ('GLOBAL.ADD' | translate)
          : ('SLIDESHOW.NEXT' | translate)
      "
      [cancelText]="
        $step() === 0 ? ('MODAL.DEFAULT.CANCEL' | translate) : ('GLOBAL.PREV' | translate)
      "
      [disabledSubmit]="
        form.invalid ||
        (isLoading$ | async) ||
        (activeTab === enums.SlotKind.program && !(hasPrograms$ | async)) ||
        (activeTab === enums.SlotKind.playlist && !(hasPlaylists$ | async))
      "
      (submitted)="$step() === 3 ? saveClicked() : nextStep()"
      (cancelled)="$step() === 0 ? closeSelf() : prevStep()"
    ></rk-footer-actions>
  </div>
}

<ng-template let-playlist="item" #renderPlaylistDropdownItemTmpl>
  <div class="dropdown-playlist-title-container">
    <rk-playlist-icon
      class="dropdown-playlist-color"
      [playlist]="playlist"
    ></rk-playlist-icon>
    <div class="dropdown-playlist-title">
      {{ playlist.name }}
    </div>
  </div>
</ng-template>
<ng-template let-playlist="item" #renderPlaylistDropdownIconTmpl>
  <rk-playlist-icon
    class="dropdown-playlist-color--selected absolute -bottom-1"
    [playlist]="playlist"
  ></rk-playlist-icon>
</ng-template>
